module.exports = __webpack_public_path__ + "img/48.dbabf8e0.png";